export enum BranchEnum {
  CuChi = "CuChi", //Củ chi
  TaUyen = "TaUyen", // Tạ uyên
}
